module.exports = __webpack_public_path__ + "media/images/default/pages/about/郭家穎-36b20e155ac8d25198778eb6e3448854.jpeg";